import React, { useState } from 'react';
import { LayoutDashboard, MessageSquare, TrendingUp, Bell, Lock, Shield } from 'lucide-react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { ChangePasswordModal } from '../../components/modals/ChangePasswordModal';
import { Setup2FAModal } from '../../components/modals/Setup2FAModal';
export function SettingsPage() {
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [is2FAModalOpen, setIs2FAModalOpen] = useState(false);
  const [settings, setSettings] = useState({
    emailNotifications: true,
    smsNotifications: false,
    inquiryAlerts: true,
    marketingEmails: false
  });
  const navItems = [{
    label: 'Dashboard',
    icon: LayoutDashboard,
    path: '/dashboard/seller'
  }, {
    label: 'Inquiries',
    icon: MessageSquare,
    path: '/seller/inquiries'
  }, {
    label: 'Performance',
    icon: TrendingUp,
    path: '/seller/performance'
  }];
  return <DashboardLayout title="Seller Console" personaLabel="SELLER" personaColor="bg-purple-100 text-purple-800 border-purple-200" navItems={navItems} userInitials="SK" data-id="element-5629">
      <h1 className="text-2xl font-bold mb-8" data-id="element-5630">Account Settings</h1>

      {/* Profile Section */}
      <div className="bg-white border border-gray-300 p-6 mb-6" data-id="element-5631">
        <h2 className="font-bold text-lg mb-4 pb-2 border-b border-gray-200" data-id="element-5632">
          Profile Information
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5633">
          <div data-id="element-5634">
            <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5635">
              Full Name
            </label>
            <input type="text" defaultValue="Rajesh Kumar" className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5636" />
          </div>
          <div data-id="element-5637">
            <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5638">
              Email
            </label>
            <input type="email" defaultValue="rajesh@example.com" className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5639" />
          </div>
          <div data-id="element-5640">
            <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5641">
              Phone
            </label>
            <input type="tel" defaultValue="+91 98765 43210" className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5642" />
          </div>
          <div data-id="element-5643">
            <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5644">
              Location
            </label>
            <input type="text" defaultValue="Pune, Maharashtra" className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5645" />
          </div>
        </div>
        <div className="mt-6 flex justify-end" data-id="element-5646">
          <button className="px-6 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-5647">
            Save Changes
          </button>
        </div>
      </div>

      {/* Security Section */}
      <div className="bg-white border border-gray-300 p-6 mb-6" data-id="element-5648">
        <h2 className="font-bold text-lg mb-4 pb-2 border-b border-gray-200 flex items-center gap-2" data-id="element-5649">
          <Shield className="w-5 h-5" data-id="element-5650" />
          Security
        </h2>
        <div className="space-y-4" data-id="element-5651">
          <div className="flex items-center justify-between p-4 border border-gray-200 bg-gray-50" data-id="element-5652">
            <div data-id="element-5653">
              <div className="font-bold text-sm mb-1" data-id="element-5654">Password</div>
              <div className="text-xs text-gray-500" data-id="element-5655">
                Last changed 3 months ago
              </div>
            </div>
            <button onClick={() => setIsPasswordModalOpen(true)} className="px-4 py-2 border border-gray-300 text-sm font-bold hover:bg-white" data-id="element-5656">
              Change Password
            </button>
          </div>
          <div className="flex items-center justify-between p-4 border border-gray-200 bg-gray-50" data-id="element-5657">
            <div data-id="element-5658">
              <div className="font-bold text-sm mb-1" data-id="element-5659">
                Two-Factor Authentication
              </div>
              <div className="text-xs text-gray-500" data-id="element-5660">
                Add extra security to your account
              </div>
            </div>
            <button onClick={() => setIs2FAModalOpen(true)} className="px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-5661">
              Enable 2FA
            </button>
          </div>
        </div>
      </div>

      {/* Notification Preferences */}
      <div className="bg-white border border-gray-300 p-6" data-id="element-5662">
        <h2 className="font-bold text-lg mb-4 pb-2 border-b border-gray-200 flex items-center gap-2" data-id="element-5663">
          <Bell className="w-5 h-5" data-id="element-5664" />
          Notification Preferences
        </h2>
        <div className="space-y-4" data-id="element-5665">
          <label className="flex items-center justify-between p-3 border border-gray-200 hover:bg-gray-50 cursor-pointer" data-id="element-5666">
            <div data-id="element-5667">
              <div className="font-bold text-sm" data-id="element-5668">Email Notifications</div>
              <div className="text-xs text-gray-500" data-id="element-5669">
                Receive updates via email
              </div>
            </div>
            <input type="checkbox" checked={settings.emailNotifications} onChange={e => setSettings({
            ...settings,
            emailNotifications: e.target.checked
          })} className="w-4 h-4 accent-[#1f2933]" data-id="element-5670" />
          </label>
          <label className="flex items-center justify-between p-3 border border-gray-200 hover:bg-gray-50 cursor-pointer" data-id="element-5671">
            <div data-id="element-5672">
              <div className="font-bold text-sm" data-id="element-5673">SMS Notifications</div>
              <div className="text-xs text-gray-500" data-id="element-5674">
                Receive updates via SMS
              </div>
            </div>
            <input type="checkbox" checked={settings.smsNotifications} onChange={e => setSettings({
            ...settings,
            smsNotifications: e.target.checked
          })} className="w-4 h-4 accent-[#1f2933]" data-id="element-5675" />
          </label>
          <label className="flex items-center justify-between p-3 border border-gray-200 hover:bg-gray-50 cursor-pointer" data-id="element-5676">
            <div data-id="element-5677">
              <div className="font-bold text-sm" data-id="element-5678">New Inquiry Alerts</div>
              <div className="text-xs text-gray-500" data-id="element-5679">
                Get notified of new inquiries instantly
              </div>
            </div>
            <input type="checkbox" checked={settings.inquiryAlerts} onChange={e => setSettings({
            ...settings,
            inquiryAlerts: e.target.checked
          })} className="w-4 h-4 accent-[#1f2933]" data-id="element-5680" />
          </label>
          <label className="flex items-center justify-between p-3 border border-gray-200 hover:bg-gray-50 cursor-pointer" data-id="element-5681">
            <div data-id="element-5682">
              <div className="font-bold text-sm" data-id="element-5683">Marketing Emails</div>
              <div className="text-xs text-gray-500" data-id="element-5684">
                Receive tips and platform updates
              </div>
            </div>
            <input type="checkbox" checked={settings.marketingEmails} onChange={e => setSettings({
            ...settings,
            marketingEmails: e.target.checked
          })} className="w-4 h-4 accent-[#1f2933]" data-id="element-5685" />
          </label>
        </div>
      </div>

      <ChangePasswordModal isOpen={isPasswordModalOpen} onClose={() => setIsPasswordModalOpen(false)} data-id="element-5686" />

      <Setup2FAModal isOpen={is2FAModalOpen} onClose={() => setIs2FAModalOpen(false)} data-id="element-5687" />
    </DashboardLayout>;
}